import React from 'react'
import {Route, Routes as Switch} from 'react-router-dom'
import * as ROUTES from '../constants/routes';
import { 
        Home,
        About,
        Projects, 
        Hire } from '../pages';

export default function Routes(){
    return(
        <Switch>
            <Route exact path={ROUTES.HOME} element={<Home />} />
            <Route path={ROUTES.ABOUT} element={<About />} />
            <Route path={ROUTES.PROJECTS} element={<Projects />} />
            <Route path={ROUTES.HIRE_ME} element={<Hire />} />
        </Switch>
    )
}